import React from 'react';
import ReactPaginate from 'react-paginate';

export default function VacancyOverviewPagination({ currentPage, totalPages, onPageChange }) {
    const isLargeDesktop = window.matchMedia('(min-width: 1280px)').matches;

    if (totalPages <= 1) return null;

    return (
        <nav
            className="d-flex justify-content-center mt-4"
            aria-label="Vacature paginering"
            role="navigation"
        >
            <ReactPaginate
                previousLabel=""
                previousClassName="page-item page-item--prev"
                previousLinkClassName="page-link text-right"
                nextLabel=""
                nextClassName="page-item page-item--next"
                nextLinkClassName="page-link text-left"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                activeClassName="active"
                disabledClassName="disabled"
                pageCount={totalPages}
                marginPagesDisplayed={isLargeDesktop ? 2 : 1}
                pageRangeDisplayed={isLargeDesktop ? 3 : 2}
                forcePage={currentPage - 1}
                onPageChange={(selectedItem) => {
                    onPageChange(selectedItem.selected + 1);
                }}
            />
        </nav>
    );
}
